export default __webpack_public_path__ + "c10d7b133f6a6e34102194425a5caef9.png";